import React, { ReactNode } from 'react';
// @mui
import { Typography, Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
import { FeatureBadge } from 'src/components/subscription/AccountBadge';

type GrayBoxSectionProps = {
  title?: string;
  subtitle?: string;
  children?: ReactNode;
  displayFeatureBadge?: boolean;
}

const StyledGridContainer = styled(Box)(({ theme }) => ({
  border: '1px solid rgba(145, 158, 171, 0.24)',
}));

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  padding: theme.spacing(2),
}));

const GrayBoxSection = ({ title, subtitle, displayFeatureBadge, children }: GrayBoxSectionProps) => {
  return (
    <StyledGridContainer>
      {(title || subtitle) && 
      <StyledBox>

        {title &&
          <Stack direction={'row'} spacing={1} sx={{ mb: subtitle ? 1 : 0, flexWrap: 'wrap' }}>
            <Typography variant="subtitle1">{title}</Typography>
            {displayFeatureBadge && <FeatureBadge />}
          </Stack>
        }

        {subtitle &&
          <Typography variant="body2" className={displayFeatureBadge ? 'disabled-feature' : ''}>
            {subtitle}
          </Typography>
        }

      </StyledBox>
      }

      {children && <>{children}</>}
    </StyledGridContainer>
  )
}

export { GrayBoxSection };
